import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';

import ApplyCSS from './../../../components/ApplyCSS';
import commonUtil from './../../../utils/commonUtil';
import Banner from './components/Banner';
import BannerImageSection from './components/BannerImageSection';

import GiftSteps from './components/GiftSteps';
import Event from './components/Event';
import AppEvents from '../../App/AppEvents';

import OffersEvent from './components/OffersEvent';
import * as labelsActions from '../../../components/labels/actions';
import * as getGlobleObject from '../../../components/globleObject/reducer';
import * as targetterContentActions from './actions';
import * as EventCategoryActions from '../../../components/eventcategory/actions';
import * as createEventObject from '../../createEvent/actions';

import serverClientUtil from '../../../utils/serverClientUtil';
import Tagging from '../../../components/Tagging';
import FAQ from '../../../components/FAQ';

import EventModal from '../../../components/EventModal/EventModal';
import InputButton from '../../../components/ZUILib/InputButton';
import { eventNames } from 'superagent';
import UserEventsCardList from '../MarketingContentSection/components/UserEventsCardList';

const { strategy } = require('../../createEvent/createEventStrategy/strategy');

const applicationRoutes = commonUtil.getApplicationRoutes();

const { isContentLoaded, loadContent } = targetterContentActions;

const { isLablesLoaded, loadLables } = labelsActions;
const { isEventCategoryLoaded, loadEventCategoryEvent } = EventCategoryActions;
const { isCreateEventDataLoaded, defineCreateEventData } = createEventObject;

const pageName = 'grHomepage';
const buttons = [
  {
    name: 'Boda',
    route: applicationRoutes.createWedding,
  },
  {
    name: 'Bebe',
    route: applicationRoutes.createBaby,
  },
  {
    name: 'XV anos',
    route: applicationRoutes.createXVYears,
  },
  {
    name: 'Bautismo',
    route: applicationRoutes.createBaptisms,
  },
  {
    name: 'Otras Ceremonias Religiosas',
    route: applicationRoutes.createReligious,
  },
  {
    name: 'OpenHouse',
    route: applicationRoutes.createOpenHouse,
  },
  {
    name: 'Birthday',
    route: applicationRoutes.createBirthday,
  },
  {
    name: 'Mascotas',
    route: applicationRoutes.createMascotas,
  },
  {
    name: 'Otras',
    route: applicationRoutes.createOtras,
  },
];

@asyncConnect([
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isContentLoaded(getState())) {
        return dispatch(loadContent());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isLablesLoaded(getState())) {
        return dispatch(loadLables());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isEventCategoryLoaded(getState())) {
        return dispatch(loadEventCategoryEvent());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isCreateEventDataLoaded(getState(), pageName)) {
        return dispatch(defineCreateEventData('SelectMesaType', ''));
      }
      return undefined;
    },
  },
])
@connect(
  (store) => ({
    content: store.targetterContent.data,
    lables: store.labels.data,
    error: store.labels.error,
    loading: store.labels.loading,
    extraData: store.labels.extraData,
    globleObj: store.globleObject,
    eventCategoryType: store.eventcategory.data,
    createEventObjectData: store.createEventObject.data,
    user: store.user.data,
  }),
  {
    ...targetterContentActions,
    ...labelsActions,
    ...getGlobleObject,
    ...createEventObject,
  },
)
class HomePage extends Component {
  constructor(props) {
    super(props);
    this.wapBackButtonEvent = null;
    this.state = {
      showModal: false,
      route: '/',
      eventName: '',
    };
  }

  static propTypes = {
    lables: PropTypes.object,
  };

  componentDidMount() {
    this.homepageBindclickEvent();
    this.wapBackButtonEvent = AppEvents.subscribe(
      AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED,
    );
    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [
        this.changeComponentOnBackButtonClick,
      ]);
    }
    const _dataLayer = this.getTaggingData();
    this.tagging.applyGTM('Home', _dataLayer);
    this.tagging.applyGTM('Home', this.getTaggingData2());
  }

  componentWillUnmount() {
    AppEvents.unsubscribe(this.wapBackButtonEvent);
  }

  changeComponentOnBackButtonClick = () => {
    const _url = serverClientUtil.getLPFullURL();
    window.location.href = _url;
  };

  getTaggingData = () => {
    const _dataLayer = {};
    _dataLayer.category = 'Home';
    _dataLayer.dimension8 = 'Home';
    if (
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.profileId
    ) {
      _dataLayer.userId =
        this.props.user.result.gtmUserId || this.props.user.result.profileId;
    } else {
      _dataLayer.userId = 'c7a5e24a9625b485cba934747972557f';
    }
    return _dataLayer;
  };

  getTaggingData2 = () => {
    const dataLayer = {};
    dataLayer.event = 'vPageview';
    dataLayer.actPageTitle = 'Home Mesa de Regalos';
    dataLayer.actURL = window.location.href;
    dataLayer.loginStatus = 'N';
    dataLayer.profileID = '';
    dataLayer.userID = '';
    if (
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.profileId
    ) {
      dataLayer.profileID = this.props.user.result.profileId;
      dataLayer.userID =
        this.props.user.result.gtmUserId || this.props.user.result.profileId;
    } else {
      dataLayer.userID = 'c7a5e24a9625b485cba934747972557f';
    }
    return dataLayer;
  };

  homepageBindclickEvent = () => {
    // handle click events on home page...
    if (typeof document !== 'undefined' && document && browserHistory) {
      if (document.querySelector('.tutorialBlock .btnPrimary')) {
        document.querySelector('.tutorialBlock .btnPrimary').addEventListener(
          'click',
          () => {
            browserHistory.push(applicationRoutes.mesaType);
          },
          false,
        );
      }
    }
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  handleCreateGiftTableButtonClick = async (button) => {
    this.setState({
      showModal: true,
      route: button.route,
      eventName: button.name,
    });
  };

  render() {
    const { lables, content } = this.props;

    const mainBanner =
      content &&
      content.targeterContents &&
      content.targeterContents.filter((target) => {
        const main = target.name === 'MainBannerTargeter' ? target : null;
        return main;
      });

    const StepsOfEventCreationsTypeTargeter =
      content &&
      content.targeterContents &&
      content.targeterContents.filter((target) => {
        const StepsOfEventCreations =
          target.name === 'StepsOfEventCreationTargeter' ? target : null;
        return StepsOfEventCreations;
      });

    const EventToolsTargeter =
      content &&
      content.targeterContents &&
      content.targeterContents.filter((target) => {
        const EventToolsTargeterResult =
          target.name === 'EventToolsTargeter' ? target : null;
        return EventToolsTargeterResult;
      });

    const BannerImageTargeter =
      content &&
      content.targeterContents &&
      content.targeterContents.filter((target) => {
        const BannerImageTargeterResult =
          target.name === 'BannerImageTargeter' ? target : null;
        return BannerImageTargeterResult;
      });

    const offerTargeter =
      content &&
      content.targeterContents &&
      content.targeterContents.filter((target) => {
        const offerTargeterResult =
          target.name === 'OffersTargeter' ? target : null;
        return offerTargeterResult;
      });

    const banner = mainBanner
      ? mainBanner && mainBanner.length
        ? mainBanner[0]
        : null
      : null; // eslint-disable-line no-nested-ternary

    const stepsOfEventCreationsTypeTargeter =
      StepsOfEventCreationsTypeTargeter &&
      StepsOfEventCreationsTypeTargeter.length
        ? StepsOfEventCreationsTypeTargeter[0]
        : null;

    const eventToolsTargeter =
      EventToolsTargeter && EventToolsTargeter.length
        ? EventToolsTargeter[0]
        : null;

    const bannerImageTargeter =
      BannerImageTargeter && BannerImageTargeter.length
        ? BannerImageTargeter[0]
        : null;

    const offerTrageter =
      offerTargeter && offerTargeter.length ? offerTargeter[0] : null;

    return (
      <React.Fragment>
        <Tagging ref={(tagging) => (this.tagging = tagging)} />
        <ApplyCSS pageName={pageName} title={'GR-Home...'} />
        <Banner banner={banner} lables={lables} />
        <div style={{ display: 'flex' }}>
          {buttons.map((button, index) => {
            return (
              <InputButton
                buttonAttr={{
                  type: 'button',
                  value: button.name,
                  autoFocus: false,
                  style: 'btnSecondary size-Full',
                  onClickHandler: () =>
                    this.handleCreateGiftTableButtonClick(button),
                }}
              />
            );
          })}
        </div>
        {this.props.user?.result?.myEventDetail?.length > 0 && (
          <UserEventsCardList
            eventsList={this.props.user.result.myEventDetail}
          />
        )}
        <GiftSteps
          StepsOfEventCreationsTypeTargeter={stepsOfEventCreationsTypeTargeter}
        />
        <Event EventToolsTargeter={eventToolsTargeter} />
        <BannerImageSection BannerImageTargeter={bannerImageTargeter} />
        <OffersEvent offerTargeter={offerTrageter} />
        {this.state.showModal && (
          <EventModal
            route={this.state.route}
            closeModal={this.closeModal}
            event={this.state.eventName}
          />
        )}
        <FAQ page='guest' />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  lables: state.labels.data,
  user: state.user.data,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ getGlobleObject }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(HomePage);
